import Style from "./style"

import Pagenation from "widget/Pagenation"

import useGetMyStoreStoreSticketRecord from "entity/store/useGetMyStoreTicketRecord"

import TStyle from "shared/style/tableStyle"
import timestampCalculator from "shared/lib/timestampCalculator"
import { convertRecordTypeAsName } from "shared/constant/lookup/recordType"

const MyStoreTicketRecord = () => {
    const [myTicketRecord] = useGetMyStoreStoreSticketRecord()

    const recordSizeList = ["short", "medium", "long", "long", "expand", "medium", "short", "long"]
    const recordTableHeadList = ["IDX", "사용자 IDX", "사용자 이름", "사용자 닉네임", "사용처", "분류", "개수", "기록 날짜"]

    return (
        <Style.Wrapper>

            <Style.Area $expand>
                <h2>매장 이용권 사용 기록</h2>

                <TStyle.TableDiv>
                    <TStyle.TableRow $title>
                        {recordTableHeadList.map((elem, index) =>
                            <TStyle.Data $title $size={recordSizeList[index]}>{elem}</TStyle.Data>
                        )}
                    </TStyle.TableRow>
                    {myTicketRecord?.data?.store_ticket_record?.map((elem, index) =>
                        <TStyle.TableRow $odd={index % 2 === 1}>
                            <TStyle.Data $size={recordSizeList[0]}>{elem?.idx}</TStyle.Data>
                            <TStyle.Data $size={recordSizeList[1]}>{elem?.account_idx}</TStyle.Data>
                            <TStyle.Data $size={recordSizeList[2]}>{elem?.account_name}</TStyle.Data>
                            <TStyle.Data $size={recordSizeList[3]}>{elem?.account_nickname}</TStyle.Data>
                            <TStyle.Data $size={recordSizeList[4]}>{elem?.event_name || "-"}</TStyle.Data>
                            <TStyle.Data $size={recordSizeList[5]}>{convertRecordTypeAsName[elem?.ticket_record_type_flag]}</TStyle.Data>
                            <TStyle.Data $size={recordSizeList[6]}>{elem?.number}</TStyle.Data>
                            <TStyle.Data $size={recordSizeList[7]}>{timestampCalculator(elem?.created_at)}</TStyle.Data>
                        </TStyle.TableRow>
                    )}
                </TStyle.TableDiv>

                <Pagenation maxPage={myTicketRecord?.data?.max_page} />
            </Style.Area>

        </Style.Wrapper>
    )
}

export default MyStoreTicketRecord